import { Observable } from 'rxjs/Rx';
import { log } from 'util';
import { ActivatedRoute, Router } from '@angular/router';
import { ABMRolesService } from '../../../services/abm-roles-service';
import { Location } from '@angular/common';
import {Component, OnInit, ViewChild, OnDestroy, AfterViewInit} from '@angular/core';
import { ColaboradoresService } from '../../../services/colaboradores-service';
import { NavigationService } from '../../../services/navigation-service';
import { PATH_ABM } from '../../../navigation/navigation.module';
import { ProductoService } from '../../../services/producto-service';
import { SpinnerService } from '../../../services/spinner-service';
import { MdSnackBar } from '@angular/material';
import { PermisosService } from '../../../services/permisos-service';
import { PermisosDetailComponent } from '../permisos-detail/permisos-detail.component';
import {DialogsService} from '../../../services';

@Component({
  selector: 'app-rol-detail',
  templateUrl: './rol-detail.component.html',
  styleUrls: ['./rol-detail.component.scss']
})
export class RolDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  private rolId;
  private rol;
  @ViewChild('rolNameInput') rolNameInput;

  EMPRESAS_VIEW = {
    TODOS: 'TODOS',
    SELECCIONADOS: 'SELECCIONADOS',
    DESELECCIONADOS: 'DESELECCIONADOS'
  };

  categoriasShowSelected = true;
  categoriasShowUnselected = true;
  categorias = [];

  acopiosShowSelected = true;
  acopiosShowUnselected = true;
  acopios = [];
  allAcopios = [];

  empresasShowSelected = true;
  empresasShowUnselected = true;
  empresas = [];

  colaboradores = [];
  colaboradoresShowSelected = true;
  colaboradoresShowUnselected = true;

  editNameMode = false;
  rolName = 'Nuevo Rol';

  firstTabLoaded: boolean = false;
  secondTabLoaded: boolean = false;

  renderedEmpresas = [];
  renderedEmpresasPage = 1;
  renderedEmpresasView = this.EMPRESAS_VIEW.TODOS;

  firstLoad = true;

  previouslyCheckedIds = [];

  empresasToAdd = [];
  empresasToRemove = [];
  empresasOrginal = [];

  private scrollSubscriber;

  permisosList = [];
  permisoSelected = null;
  permisoSelectedId = null;
  @ViewChild(PermisosDetailComponent) permisoDetailComponent;

  rolLoading = false;
  visibleClientes = false;

  constructor(private route: ActivatedRoute,
              private location: Location,
              private colaboradoresService: ColaboradoresService,
              private abmRolesService: ABMRolesService,
              private router: Router,
              private navService: NavigationService,
              private productoService: ProductoService,
              private spinnerService: SpinnerService,
              private snackBar: MdSnackBar,
              private permisosService: PermisosService,
              private dialogsService: DialogsService) {
    this.permisosService.verificarAccesoDeURL();
    this.permisosService.loadOptions();
    this.permisosService.getAllPermisos().subscribe(x => {
      if (x) {
        this.permisosList = x;
      }
    });
  }

  ngOnInit() {
    this.firstLoad = true;
    this.route.params.subscribe(params => {
      this.rolId = this.route.snapshot.params['id'];
      this.loadData();
    });
  }

  loadData() {
    if (this.rolId) {
      this.rolLoading = true;
      this.abmRolesService.getRol(this.rolId)
        .subscribe(data => {
          this.rol = data;
          this.visibleClientes = this.rol.VisibleClientes;
          this.rolName = data.RolName;
          this.permisoSelected = data.Permiso;
          this.permisoSelectedId = data.Permiso.PermisoId;
          this.getColaboradores();
          this.getCategorias();
          this.rolLoading = false;
        });
    } else {
      this.getColaboradores();
      this.getCategorias();
    }

  }

  getAcopios() {
    this.abmRolesService.getAcopios()
      .subscribe(data => {
        this.allAcopios = data;
        this.displayAcopios(true);
        if (this.rolId) {
          this.checkAcopios();
          this.getCuentasByAcopiosIds();
        } else {
          this.firstTabLoaded = true;
        }
      });
  }

  getColaboradores() {
    this.colaboradoresService.getAllColaboradores()
      .subscribe(data => {
        this.colaboradores = data;
        if (this.rolId) {
          this.checkColaboradores();
        }
        this.secondTabLoaded = true;
      });
  }

  getCuentasByAcopiosIds() {

    let ids = [];

    for (let acopio of this.acopios){
      if (acopio.checked){
        ids.push(acopio.Id);
      }
    }

    if (this.firstLoad) {
      this.firstLoad = false;
    } else {
      this.spinnerService.setShowFlag(true);
    }

    this.abmRolesService.getCuentasByAcopiosIds(ids)
      .subscribe(data => {
        // si ya hay empresas, guardar la info de los chequeados en caso de requerir
        if (this.empresas.length) {
          this.previouslyCheckedIds = this.empresas.filter(x => x.checked === true).map(y => y.Id);
        }

        const parsedData = [];

        for (let i = 0; i < data.Id.length; i++) {
          parsedData.push({
            Id: data.Id[i],
            FullName: data.Name[i]
          });
        }

        this.empresas = parsedData;

        this.checkEmpresas();
        this.firstTabLoaded = true;
        this.renderedEmpresasPage = 1;
        this.updateEmpresasList();

        this.spinnerService.setShowFlag(false);
      }, err => this.spinnerService.setShowFlag(false));
  }

  checkEmpresas() {
    for (const empresa of this.empresas) {
      if (this.rol) {
        empresa.checked = this.rol.Empresas.includes(empresa.Id);
      } else {
        // si no hay rol se está creando, crear la variable y chequear las anteriores
        empresa.checked = this.previouslyCheckedIds.includes(empresa.Id);
      }
    }
  }

  ngAfterViewInit() {
    const content = document.querySelector('.filtered-empresas');

    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        const max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7) {
          this.renderedEmpresasPage = this.renderedEmpresasPage + 1;
          this.updateEmpresasList();
        }
      });
  }

  getCategorias() {
    this.abmRolesService.getCategorias()
      .subscribe(data => {
        this.categorias = data;
        if (this.rolId) {
          this.checkCategorias();
        }
        this.getAcopios();
      });
  }

  onSelectAll(collection, isEmpresas = false) {

    if (isEmpresas) {

      this.empresas.forEach(x => {
        x.checked = true;
      });
      this.updateEmpresasList();

    } else {

      for (const c of collection){
        (c as any).checked = true;
      }
      this.displayAcopios();
    }
  }

  onUnselectAll(collection, isEmpresas = false) {

    if (isEmpresas) {

      this.empresas.forEach(x => {
        x.checked = false;
      });
      this.updateEmpresasList();

    } else {
      for (const c of collection){
        (c as any).checked = false;
      }
      this.displayAcopios();
    }
  }

  onEmpresaChecked(empresa, e) {
    // el proceso difiere si estamos creando a si estamos editando un rol
    // al crear un rol, le enviamos la lista de empresas checked, al editar le enviamos las que entraron y salieron
    if (this.rol) {
      if (e.checked) {
        // estamos agregando un nivel, nos fijamos si está en la lista original
        if (this.rol.Empresas.findIndex(x => x === empresa.Id) < 0) {
          this.empresasToAdd.push(empresa.Id);
        }
        // si estaba en la lista de remove, quitarla
        this.empresasToRemove = this.empresasToRemove.filter(x => x !== empresa.Id);
      } else {
        // estamos quitando un nivel
        if (this.rol.Empresas.findIndex(x => x === empresa.Id) >= 0) {
          this.empresasToRemove.push(empresa.Id);
        }
        // si estaba en la lista de add, quitarla
        this.empresasToAdd = this.empresasToAdd.filter(x => x !== empresa.Id);
      }
    }

    empresa.checked = e.checked;
    if (this.renderedEmpresasView !== this.EMPRESAS_VIEW.TODOS) {
      this.updateEmpresasList();
    }
  }

  onCategoriaChecked(categoria, checked) {
    categoria.checked = checked;
    this.displayAcopios();
  }

  onAcopioChecked(acopio, checked) {
    acopio.checked = checked;
    this.getCuentasByAcopiosIds();
  }



  displayAcopios(dontLoadCuentas?) {
    this.acopios = [];

    for (const categoria of this.categorias) {
      if (categoria.checked) {
        this.acopios = this.acopios.concat(categoria.Acopios);
      }
    }
    this.acopios.sort(function(a, b) {
      if (a.AcopioNombre < b.AcopioNombre) {
        return -1;
      }
      if (a.AcopioNombre > b.AcopioNombre) {
        return 1;
      }
      return 0;
    });
    if (this.acopios.length && !dontLoadCuentas) {
      this.getCuentasByAcopiosIds();
    }
  }

  checkCategorias() {
    for (let categoria of this.categorias){
      if (this.rol.Categorias.includes(categoria.Id)) {
        categoria.checked = true;
      }
    }
  }

  checkAcopios() {
    for (let acopio of this.acopios){
      if (this.rol.Acopios.includes(acopio.Id)) {
        acopio.checked = true;
      }
    }
  }

  checkColaboradores() {
    for (let colaborador of this.colaboradores) {
      if (this.rol.Colaboradores.includes(colaborador.UserId)) {
        colaborador.checked = true;
      }
    }
  }

  onSubmit() {
    const categorias = [];
    const acopios = [];
    const empresas = [];
    const colaboradores = [];
    const productos = [];

    if (this.permisoSelectedId === null) {
      this.snackBar.open('No se seleccionó nungún conjunto de permisos. Por favor, seleccione uno en la solapa "Visibilidad"', '', {
        duration: 4000,
      });
      return;
    }

    for (const item of this.categorias) {
      if (item.checked) {
       categorias.push(item.Id);
      }
    }

    for (const item of this.acopios) {
      if (item.checked) {
        acopios.push(item.Id);
      }
    }

    for (const item of this.empresas) {
      if (item.checked) {
        empresas.push(item.Id);
      }
    }

    for (const item of this.colaboradores) {
      if (item.checked) {
        colaboradores.push(item.UserId);
      }
    }


    this.spinnerService.setShowFlag(true);

    if (this.rol) {
      this.abmRolesService.updateRol(
        this.rol.Id,
        this.rolName,
        categorias,
        acopios,
        // no le enviamos las empresas
        [],
        colaboradores,
        this.empresasToAdd,
        this.empresasToRemove,
        this.permisoSelectedId,
        this.visibleClientes
      ).subscribe(data => {
        this.spinnerService.setShowFlag(false);
        this.onNavigateBack();
      }, err => {
        this.spinnerService.setShowFlag(false);
        this.snackBar.open('Ocurrió un error al enviar esta solicitud', '', {
          duration: 2000,
        });
      });
    } else {
      this.abmRolesService.createRol(
        this.rolName,
        categorias,
        acopios,
        empresas,
        colaboradores,
        this.permisoSelectedId,
        this.visibleClientes
      ).subscribe(data => {
        this.spinnerService.setShowFlag(false);
        this.onNavigateBack();
      }, err => {
        this.spinnerService.setShowFlag(false);
        this.snackBar.open('Ocurrió un error al enviar esta solicitud', '', {
          duration: 2000,
        });
      });
    }
  }

  onNavigateBack() {
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_ABM + '/roles');
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  // al cambiar la vista de seleccionados, no seleccionados o todos
  onEmpresaViewChange(newView) {
    if (this.renderedEmpresasView !== newView) {
      this.renderedEmpresasView = newView;
      this.renderedEmpresasPage = 1;
      this.updateEmpresasList();
    }
  }

  updateEmpresasList() {
    switch (this.renderedEmpresasView) {
      case this.EMPRESAS_VIEW.TODOS:
        this.renderedEmpresas = this.empresas.slice(0, 50 * this.renderedEmpresasPage);
        break;

      case this.EMPRESAS_VIEW.SELECCIONADOS:
        const empresasTrueFiltered = this.empresas.filter(x => x.checked === true);
        this.renderedEmpresas = empresasTrueFiltered.slice(0, 50 * this.renderedEmpresasPage);
        break;

      case this.EMPRESAS_VIEW.DESELECCIONADOS:
        const empresasFalseFiltered = this.empresas.filter(x => x.checked === false);
        this.renderedEmpresas = empresasFalseFiltered.slice(0, 50 * this.renderedEmpresasPage);
        break;
    }
  }

  // luego de seleccionar un permiso, lo buscamos para visualizarlo
  searchPermiso(e) {
    this.permisoSelected = this.permisosList[this.permisosList.findIndex(x => x.PermisoId === e.value)];
    this.setupPermisoPreview();
  }

  setupPermisoPreview() {
    this.permisoDetailComponent.setPermiso(this.permisoSelected);
  }

  visibleClientesChanged(e): void {
    this.visibleClientes = e.checked;
  }

  openClientesVisibilidadModal(): void {
    this.dialogsService.confirm(
      'Visibilidad en sistema de Usuarios',
      'Si activa esta opcion, este Rol será visible y seleccionable<br>como Acopio de usuarios en el sistema de Clientes',
      'Aceptar',
      '',
      false);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/rol-detail/rol-detail.component.ts